///

/// 多角形を構成する頂点リストと対象点とを使って、対象点が多角形内に含まれるかをテストする
///

class Picker {
    private _unit : number = 1 / (2 * Math.PI);

    ///

    public intersection() {

    }
    /// 調査点が多角形の内外どちらにあるかを判定する
    ///

    /// 多角形を構成する頂点リスト
    /// 調査点
    /// 多角形が存在する平面の法線
    /// 調査点が内側にある場合はtrue
    public _Check(positions : THREE.Vector2[], target : THREE.Vector2) : boolean {
      let result = 0;

      let minX = Number.MAX_VALUE;
      let maxX = -Number.MAX_VALUE;
      let minY = Number.MAX_VALUE;
      let maxY = -Number.MAX_VALUE;

      for (let i = 0; i < positions.length; i++) {
        minX = Math.min(minX, positions[i].x);
        maxX = Math.max(maxX, positions[i].x);
        minY = Math.min(minY, positions[i].y);
        maxY = Math.max(maxY, positions[i].y);
      }

      if (minX > target.x || maxX < target.x) return false;
      if (minY > target.y || maxY < target.y) return false;

      for (let i = 0; i < positions.length; i++) {
        const l1 = positions[i].clone().sub(target).normalize();
        const l2 = positions[(i + 1) % positions.length].clone().sub(target).normalize();

        let rad = Math.acos(l1.dot(l2));

        if (l1.cross(l2) < 0.0) {
          rad *= -1;
        }

        result += rad;
      }

      result *= this._unit;

      // 時計回り・反時計回りどちらもありえるため絶対値で判定する
      return Math.abs(result) >= 0.01;
    }
}

export default Picker;
